import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-container",
  ref: "target"
}
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OnClickOutside = _resolveComponent("OnClickOutside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OnClickOutside, {
        onTrigger: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('modal-cancel')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "header", {}, () => [
                _cache[2] || (_cache[2] = _createTextVNode(" default header"))
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "content", {}, () => [
                _cache[3] || (_cache[3] = _createTextVNode(" default content"))
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "footer", {}, () => [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('modal-close')), ["stop"]))
                  }, "Submit")
                ])
              ])
            ])
          ], 512)
        ]),
        _: 3
      })
    ])
  ]))
}